import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import { getTransactionInvoiceDetail } from "../../api/invoice";
import {
  GridComp12,
  GridComp4,
  GridComp6,
} from "../../components/GridComponents";
import { CustomCheckBox } from "../../components/CheckboxComp";
import { makeStyles } from "@mui/styles";
import CashSaleItems from "./cash-sale/items";
import CashSaleShipping from "./cash-sale/shipping";
import CashSaleBilling from "./cash-sale/billing";
import CashSaleAccounting from "./cash-sale/accounting";
import CashSaleRelationship from "./cash-sale/relationship";
import CashSaleCommunication from "./cash-sale/communication";
import CashSaleRelatedRecords from "./cash-sale/related-records";
import CashSaleSystemInformation from "./cash-sale/systemInformation";
import CashSaleCustom from "./cash-sale/custom";
import CashSaleCharges from "./cash-sale/charges";
import CashSaleEft from "./cash-sale/eft";
import CashSaleAvaTax from "./cash-sale/ava-tax";
import { getTransactionCashSaleDetail } from "../../api/transaction-type";
const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function TransactionTypeCashSale() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const params = useParams();
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [tabIndexApproveList, setTabIndexApproveList] = useState(0);
  const [tabIndexAvaTax, setTabIndexAvaTax] = useState(0);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [itemsum, setSum] = useState("");
  /*----------------End Tabs-----------------*/
  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCashSaleDetail(user.token, {
        tranid: params.docNo,
        // type: pageDetail.path,
      });
      setSum(data.data.itemsum)
      setData(data.data);
      setRowData(data.data.details[0]);
      setLoading(false);

      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);

      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
 
  return loading ? (
    <>
      <Typography component="h2" fontWeight={500} className="pageTitle">
        Cash Sale
      </Typography>

      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        ></Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Cash Sale
      </Typography>
      <Typography component="p" style={{ marginBottom: "10px" }}>
        <span className="para-no">
          <strong>{rowData?.sale_number}</strong> {rowData?.customer_name}
        </span>{" "}
        <Button className="blue-button" size="small" style={{ marginLeft: 4 }}>
          {rowData?.status}
        </Button>
      </Typography>

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={8}>
                <Grid container className="mb-2">
                  <GridComp6 title={"SALE#"} data={rowData?.sale_number} />
                  <GridComp6 title={"DATE"} data={rowData?.date} />
                  <GridComp6
                    title={"TRANSACTION NUMBER"}
                    data={rowData?.transactionnumber}
                  />
                  <GridComp6
                    title={"POSTING PERIOD"}
                    data={rowData?.postingperiod}
                  />
                  <GridComp6 title={"CUSTOMER"} data={rowData?.customer_name} />

                  <GridComp6 title={"REF#"} data={rowData?.refrence_num} />
                  <GridComp6 title={"PC/PROJECT"} data={rowData?.pc_project} />
                  <GridComp6 title={"MEMO"} data={rowData?.memo} />
                </Grid>
              </Grid>
              {/* -----------Summary Box------------- */}
              <Grid item xs={12} sm={6} md={4}>
                <Box className="viewBox">
                  <Box
                    className="headerItemsSB"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    pb={2}
                  >
                    <Typography
                      component="h5"
                      fontWeight={500}
                      className="pageHeading1"
                    >
                      Summary
                    </Typography>
                  </Box>
                  <Box className="viewDetilsBox1">
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">SUBTOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">{rowData?.sub_total}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">TAX TOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">{rowData?.total_tax}</p>
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container sx={{ mt: 1 }}>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">TOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">{data?.total}</p>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>

      {/*Classification*/}

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid container className="mb-2">
              <GridComp4 title={"SUBSIDIARY"} data={rowData.subsidiary} />

              <GridComp4 title={"DEPARTMENT"} data={rowData.department} />
              <GridComp4 title={"SERVICE LINE"} data={rowData.service_line} />
              <GridComp4 title={"LOCATION"} data={rowData.location} />
              <GridComp4
                title={"INVOICE MESSAGING"}
                data={rowData.invoice_msg}
              />
              <GridComp4
                title={"SERVICE PERIOD"}
                data={rowData.service_period}
              />
              <GridComp4
                title={"LINKED CUSTOMER RECORD"}
                data={rowData.linked_customer_record}
              />
               <Grid item xs={12} sm={6} md={4} className="m-b-10">
                            <p className="tFormlabel checkAndTextAlign">
                              {rowData?.seller_imported_record ===
                                "false" ||
                              rowData?.seller_imported_record ===
                                null ? (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                  IS SELLER IMPORTER OF RECORD
                                </>
                              ) : (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox checked disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                  IS SELLER IMPORTER OF RECORD
                                </>
                              )}
                            </p>
                          </Grid>
            
              <GridComp4
                title={"CUSTOM DUTY AND IMPORT FEES"}
                data={rowData.custom_duty_importfee}
              />
              <GridComp4
                title={"SHIP TO ENTITY/USE CODE"}
                data={rowData.shiptousecode}
              />
              <GridComp4 title={"PROJECT ID"} data={rowData.projectid} />
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                            <p className="tFormlabel checkAndTextAlign">
                              {rowData?.exclude_from_ep_process ===
                                "false" ||
                              rowData?.exclude_from_ep_process ===
                                null ? (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                 EXCLUDE FORM ELECTRONIC BANK PAYMENTS PROCESSING
                                </>
                              ) : (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox checked disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                 EXCLUDE FORM ELECTRONIC BANK PAYMENTS PROCESSING
                                </>
                              )}
                            </p>
                          </Grid>
             
              <GridComp4
                title={"BILL TO ENTITY/USE CODE"}
                data={rowData.bill_to_entity_use_code}
              />
              <GridComp4 title={"CUSTOMER ID"} data={rowData.customerid} />
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                            <p className="tFormlabel checkAndTextAlign">
                              {rowData?.disable_tax_calculation ===
                                "false" ||
                              rowData?.disable_tax_calculation ===
                                null ? (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                DISABLE AVALARA TAX CALCULAION
                                </>
                              ) : (
                                <>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox checked disabled />}
                                      label=""
                                    />
                                  </FormGroup>
                                DISABLE AVALARA TAX CALCULAION
                                </>
                              )}
                            </p>
                          </Grid>
             
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={`${classes.spacedTabs} tabs-bkg`}
            // className="tabs-bkg"
          >
            <Tab style={{ padding: "0px 10px" }} label={`Items ${itemsum}`||"0.00"} />
            <Tab label="Shipping" />
            <Tab label="Billing" />
            <Tab label="Accounting" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="Charges" />
            <Tab label="EFT" />
            {/* <Tab label="Tax Reporting" /> */}
            <Tab label="AvaTax" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
           <CashSaleItems setSum={setSum} />
          </TabPanel>
          {/*------------Shipping-----------*/}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && (  <CashSaleShipping tabIndexP={tabIndex} /> )}
          </TabPanel>
          {/*------------billing-----------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && (  <CashSaleBilling tabIndexP={tabIndex} /> )}
          </TabPanel>
          {/*------------Accounting------------*/}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && (  <CashSaleAccounting tabIndexP={tabIndex} /> )}
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && (  <CashSaleRelationship tabIndexP={tabIndex} /> )}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && (  <CashSaleCommunication tabIndexP={tabIndex} /> )}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && <CashSaleRelatedRecords tabIndexP={tabIndex} />}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={7}>
            {tabIndex === 7 && <CashSaleSystemInformation />}
          </TabPanel>

          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={8}>
          {tabIndex === 8 &&<CashSaleCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/*-------------CHARGES-----------*/}
          <TabPanel value={tabIndex} index={9}>
           {tabIndex === 9 &&  <CashSaleCharges tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={10}>
          {tabIndex === 10 &&   <CashSaleEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/*-------------Tax Reporting-----------*/}
          {/* <TabPanel value={tabIndex} index={11}>
            <InvoiceTaxAndReporting tabIndexP={tabIndex} />
          </TabPanel> */}
          {/*------------AvaTax-----------*/}
          <TabPanel value={tabIndex} index={11}>
        {tabIndex === 11 &&     <CashSaleAvaTax tabIndexP={tabIndex} />}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
